import styled from 'styled-components';

import { Headline } from 'components/Headline';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.aside`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  width: ${({ theme }) => theme.sidebarWidth};

  background-color: ${pickColor('black')};

  transition: width ${({ theme }) => theme.transitionSpeed} linear;
`;

const Inner = styled.div`
  position: relative;
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding-top: 3.3rem;
`;

const Title = styled(Headline)`
  margin: 1rem 0 0 3rem;
`;

const CategoryTitle = styled(Headline)`
  font-weight: medium;

  margin-left: 3.5rem;
`;

const CategoryTitleRow = styled.div`
  display: flex;
  align-items: center;
`;

const Li = styled.li`
  margin-bottom: 2rem;
`;

export { Container, Title, Ul, Inner, Li, CategoryTitle, CategoryTitleRow };
